import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { DashboardItem } from '../models/dashboard-item';
import { Dashboard } from '@dashboards/models/dashboard';

@Injectable()
export class UserDashboardHttpService {

  constructor(private readonly urlService: UrlBuilderService, private readonly http: HttpClient) { }

  private getUrl(dashboardId: string) {
    return this.urlService.getUrl(`user/dashboard/${dashboardId}`);
  }

  getDashboardItems(dashboardId: string): Observable<DashboardItem[]> {
    const dashboardUrl = this.getUrl(dashboardId);
    return this
      .http
      .get<DashboardItem[]>(dashboardUrl);
  }

  setDashboardItems(items: DashboardItem[], dashboardId: string) {
    const dashboardUrl = this.getUrl(dashboardId);

    return this
      .http
      .post<DashboardItem[]>(dashboardUrl, items);
    }

    getAvailableDashboardByProduct(productId: string): Observable<Dashboard[]> {
        const url = this.urlService.getUrl(`user/dashboards/${productId}`);
        return this
          .http
            .get<Dashboard[]>(url);
    }
}
